import gql from 'graphql-tag';

import integrationItemFragment from '../fragments/integrationItemFragment';

export const mutationCreateDriveIntegrationFile = gql`
  mutation createDriveIntegrationFile(
    $integrationID: DokkioID!
    $parentRemoteID: ID!
    $fileType: DriveFileType!
    $name: String
    $dokkioTagIDs: [DokkioID!]
  ) {
    createDriveIntegrationFile(
      integrationID: $integrationID
      parentRemoteID: $parentRemoteID
      fileType: $fileType
      name: $name
      dokkioTagIDs: $dokkioTagIDs
    ) {
      ...integrationItemFragment
    }
  }
  ${integrationItemFragment}
`;
export default mutationCreateDriveIntegrationFile;
